import { hillo } from 'hillo'

export async function printDailyCardTerminal () {
  return (await hillo.post('Complex.php?op=printPaymentBon', {
    overrideCardTerminalIp: '',
    overrideCardTerminalPort: ''
  }))
}
